var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useAudioPlayerContext } from './../../../hx-audio-player/src/hooks/useAudioContextContext';
import logger from 'use-reducer-logger';
import { HxHearingAidSimulator } from 'hx-hearing-aid-simulator';
import { useEffect, useReducer } from 'react';
import { minusAudio, plusAudio } from '../assets';
var initialState = {
    isInitialized: false,
    isPlaying: true,
    isInitializing: false,
    error: undefined,
    hearingAidOn: false,
    volume: 1,
};
var reducer = function (state, action) {
    switch (action.type) {
        case 'INITIALIZE':
            return __assign(__assign({}, state), { isInitializing: true });
        case 'INITIALIZE_SUCCESS':
            return __assign(__assign({}, state), { isInitializing: false, isInitialized: true });
        case 'INITIALIZE_FAILURE':
            return __assign(__assign({}, state), { isInitializing: false, error: action.error });
        case 'START':
            return __assign(__assign({}, state), { isPlaying: true });
        case 'STOP':
            return __assign(__assign({}, state), { isPlaying: false });
        case 'TOGGLE_HEARING_AID':
            return __assign(__assign({}, state), { hearingAidOn: !state.hearingAidOn });
        case 'SET_VOLUME':
            return __assign(__assign({}, state), { volume: Number(action.volume) });
        default:
            return state;
    }
};
export var useHearingAidSimulator = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.files, files = _c === void 0 ? [minusAudio, plusAudio] : _c, _d = _b.autoPlay, autoPlay = _d === void 0 ? false : _d, _e = _b.debug, debug = _e === void 0 ? process.env.REACT_APP_DEBUG === 'true' : _e, _f = _b.volume, initialVolume = _f === void 0 ? 1 : _f;
    var _g = useAudioPlayerContext(), audioContext = _g.audioContext, masterGain = _g.masterGain;
    var hearingAidSimulator = HxHearingAidSimulator.getInstance();
    var _h = useReducer(debug ? logger(reducer) : reducer, initialState), state = _h[0], dispatch = _h[1];
    var initialize = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: 'INITIALIZE' });
                    return [4 /*yield*/, hearingAidSimulator
                            .useAudioContext(audioContext)
                            .useMasterGain(masterGain)
                            .setDebug(debug)
                            .initialize(files)
                            .then(function () {
                            dispatch({ type: 'INITIALIZE_SUCCESS' });
                        })
                            .catch(function (error) {
                            dispatch({ type: 'INITIALIZE_FAILURE', error: error });
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var start = function () {
        dispatch({ type: 'START' });
    };
    var stop = function () {
        dispatch({ type: 'STOP' });
    };
    var toggleHearingAid = function () {
        dispatch({ type: 'TOGGLE_HEARING_AID' });
    };
    var setVolume = function (volume) {
        dispatch({ type: 'SET_VOLUME', volume: volume });
    };
    useEffect(function () {
        if (state.isInitialized)
            return;
        initialize().then(function () {
            setVolume(initialVolume);
            if (autoPlay)
                start();
        });
    }, [state.isInitialized]);
    useEffect(function () {
        if (!state.isInitialized)
            return;
        hearingAidSimulator.setHearingAidOn(state.hearingAidOn);
    }, [state.isInitialized, state.hearingAidOn]);
    useEffect(function () {
        if (!state.isInitialized)
            return;
        if (state.isPlaying) {
            hearingAidSimulator.start();
            hearingAidSimulator.setHearingAidOn(false);
        }
        else {
            hearingAidSimulator.stop();
        }
        return function () { return hearingAidSimulator.stop(); };
    }, [state.isPlaying, state.isInitialized]);
    useEffect(function () {
        if (!state.isInitialized)
            return;
        hearingAidSimulator.setVolume(state.volume);
    }, [state.isInitialized, state.volume]);
    return {
        state: state,
        initialize: initialize,
        start: start,
        stop: stop,
        toggleHearingAid: toggleHearingAid,
    };
};
